module.exports = new function gameLightBox() {

    var closeLb = $('.close-lb');
    var playbtn = $('[data-js="play-game"]');
    var gameIframe = $('.game-iframe');
    var lightBox = $('.game-lightbox');
    var fullscreen = $('.fullscreen-game');
    var chooseGame = $('[data-js="choose-game-type"]');
        chooseGame.hide()

    var toggleLightbox = function (e) {
        if ( e.target.className == 'close-lb' ) {
            gameIframe.removeClass('game-iframe_show');
            gameIframe.children().remove();
            gameIframe.removeClass('game-iframe_fullscreen');
            gameIframe.removeClass('game-iframe_ratio169');

            setTimeout(function() {
                lightBox.removeClass('game-lightbox_show');
            }, 400);
        }
        else {
            var btnData = $(this).data('iframe');
            var gameRatio = $(this).data('ratio');
            lightBox.toggleClass('game-lightbox_show');
            chooseGame.show();
            toggleGameMenu(btnData, gameRatio);
        }
    }

    function toggleGameMenu(src, ratio) {
        chooseGame.find('.btn').on('click', function(e) {
            const buttonType = $(e.currentTarget).attr('data-js');

            if ( buttonType === 'normal') {
                chooseGame.hide();
                showGame(src, ratio)
            } else {
                chooseGame.hide();
            }
        });
    }

    var showGame = function (src, ratio) {
        var iframe = $('<iframe frameBorder="0">').prop('src', src);
            gameIframe.addClass('game-iframe_show');
            gameIframe.addClass('game-iframe_ratio169');
            iframe.appendTo(gameIframe);
    };

    $('.back-fullscreen').on('click', function () {
        var gameIframe = $('.game-iframe iframe');
        gameIframe.fadeOut(10);
        gameIframe.removeClass('fullscreen');
        gameIframe.remove();
    });

    var gameFullscreen = function () {
        gameIframe.addClass('game-iframe_fullscreen');
    };

    $(document).keyup(function(e) {

        if ( e.keyCode === 27 ) {
            gameIframe.removeClass('game-iframe_show');
            gameIframe.removeClass('game-iframe_ratio169');
            gameIframe.children().remove();
            gameIframe.removeClass('game-iframe_fullscreen');
            setTimeout(function() {
                lightBox.removeClass('game-lightbox_show');
            }, 400);
        }

    });

    playbtn.on('click', toggleLightbox);
    closeLb.on('click', toggleLightbox);
    fullscreen.on('click', gameFullscreen);

};
